package com.gastoncantera.intercom.presence

import com.gastoncantera.intercom.auth.AuthRepository
import com.gastoncantera.intercom.push.PushTokenRegistry

/**
 * Única salida de sesión: suelta el token FCM de ESTE dispositivo y después cierra sesión.
 *
 * Salir sin soltarlo deja el token vivo en el doc del usuario que se fue, así que el próximo que se
 * loguee en el mismo equipo sigue recibiendo las llamadas del anterior (el push va al token, no al
 * usuario). Por eso todos los botones de cerrar sesión pasan por acá.
 *
 * Si la limpieza falla (típicamente sin red) igual cierra sesión: dejar al usuario adentro es peor
 * que un token viejo, que además el backend borra en el primer envío fallido.
 */
suspend fun signOutReleasingPush(
    authRepository: AuthRepository,
    presenceRepository: PresenceRepository,
    uid: String?,
) {
    if (uid != null) {
        runCatching { presenceRepository.removePushToken(uid, PushTokenRegistry.token.value) }
    }
    authRepository.signOut()
}
